import type { IMetaProductListingMessages } from '.';

const metaProductListingMessages: IMetaProductListingMessages = {
	actions: 'Actions',
	delete: 'Delete',
	distributionCenterCoverage: 'Distribution Center Coverage',
	edit: 'Edit',
	locationCoverage: 'Location Coverage',
	masterItemName: 'Master Item Name',
	masterOrderGuideIsEmpty:
		'The Master Order Guide is empty. Create a new Master Item with the "Add" button below.',
	noMatchesFoundForSearch: `We're sorry - no matches were found for {lastSearch}.`,

	noMatchesFoundWithAdditionalCoverageNeeded: `We're sorry - no matches were found with additional coverage needed. Try removing the coverage filter.`,

	noMatchesFoundWithAdditionalCoverageNeededForSearch: `We're sorry - no matches were found with additional coverage needed for {lastSearch}. Try removing the coverage filter.`,
	products: 'Products',
	uncheck: 'Uncheck',
	ungroup: 'Ungroup',
	view: 'View',
	pendingRebuild:
		'Coverage for one or more master item is currently being recalculated.',
	selectLocations: `Select Locations`,
	needLocations: `To add or edit master items, you must assign a location to this order guide. `,
	categorizeModalTitle:
		'Categorizing {count, number} {count, plural, one {Master Item} other {Master Items}}',
	itemSpecificationWidget: {
		header: 'Item Specification',
		hardSpecsPhasedOut: 'Hard Specs Phased Out',
		requiredSpecsPhasedOut: 'Required Specs Phased Out',
		hard: 'Hard',
		required: 'Required',
		open: 'Open',
		unassigned: 'Unassigned',
	},
	itemCoverageWidget: {
		header: 'Item Coverage',
		hardSpecsNeedingCoverage: 'Hard Specs Needing Coverage',
		requiredSpecsNeedingCoverage: 'Required Specs Needing Coverage',
		fullCoverage: 'Full Coverage',
		needsCoverage: 'Needs Coverage',
	},
	addCustomCategory: 'Add',
	customCategories: 'Custom Categories',
	productTable: {
		productNumber: 'Product\u00a0#',
		description: 'Description',
		brand: 'Brand',
		packSize: 'Pack Size',
		priority: 'Priority',
		leavingSoon: 'Leaving Soon',
		unitMeasureCode: 'U/M',
	},
	includeInCoverage: 'Include in Coverage',
	remote: 'Remote',
	coverageTamperedWith:
		'Coverage is being affected by the "Include in Coverage" filter below.',
};

export default metaProductListingMessages;
